export default defineAppConfig({
	ui: {
		colors: {
			primary: 'prop-green',
			neutral: 'neutral',
			secondary: 'prop-red',
			error: 'rose',
		},
		input: {
			defaultVariants: {
				size: 'md',
			},
			slots: {
				root: 'flex',
			},
		},
		textarea: {
			defaultVariants: {
				size: 'md',
			},
			slots: {
				root: 'flex',
			},
		},
		select: {
			defaultVariants: {
				size: 'md',
			},
			slots: {
				base: 'rounded-lg flex w-full',
			},
		},
		button: {
			defaultVariants: {
				size: 'md',
			},
		},
		notifications: {
			// Show toasts at the top right of the screen
			position: 'top-0 bottom-[unset]',
		},
	},
})
